import React from "react";
import "./landing.css";

/* The lines the market actually moves — the same categories the app lists,
   plus the staples that fill the crates in between. */
const LINES = [
  "Tomatoes",
  "Cucumber",
  "Iceberg",
  "Bok Choy",
  "Cauliflower",
  "Carrots",
  "Capsicum",
  "Cabbage",
  "Celery",
  "Broccoli",
  "Eggplant",
  "Courgette",
  "Onions",
  "Garlic",
  "Potatoes",
  "Parsley",
  "Mint",
  "Lemons",
  "Oranges",
  "Apples",
  "Grapes",
  "Strawberries",
];

function Row({ ariaHidden }) {
  return (
    <div className="tfm-arrivals__row" aria-hidden={ariaHidden || undefined}>
      {LINES.map((line) => (
        <span className="tfm-arrivals__item tfm-mono" key={line}>
          {line}
        </span>
      ))}
    </div>
  );
}

export default function Arrivals() {
  return (
    <div className="tfm-arrivals">
      <p className="tfm-arrivals__label tfm-mono">What we carry</p>
      <div className="tfm-arrivals__track">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
